export const articles = [
  {
    id: 'article-1',
    title: '91n.com 新用户注册完整流程指南',
    excerpt: '本文详细介绍 91n.com 新用户注册的每一个步骤，从访问官方入口到完成邮箱验证，帮助您快速拥有自己的 91n.com 账号。',
    content: `<p>欢迎来到 <strong>91n.com</strong>！作为新用户，注册账号是您使用平台全部功能的第一步。本指南将带领您逐步完成整个注册流程，确保过程顺畅无忧。</p>
<h2>第一步：访问 91n.com 官方入口</h2>
<p>打开您的浏览器，在地址栏输入 <strong>91n.com</strong> 官方网址。请务必确认您访问的是 91n.com 官方网站，避免进入仿冒或钓鱼网站。建议您将 91n.com 添加到浏览器书签，方便日后快速访问。</p>
<h2>第二步：点击注册按钮</h2>
<p>在 91n.com 首页右上角，您可以清晰地看到"注册"按钮。点击该按钮后，系统将跳转至注册页面。</p>
<h2>第三步：填写注册信息</h2>
<p>在注册页面中，您需要填写以下信息：</p>
<ul><li>用户名：建议使用英文字母和数字组合，长度 4-16 个字符</li><li>电子邮箱：请使用您常用的有效邮箱地址</li><li>密码：至少 8 位，需包含大小写字母和数字</li><li>验证码：输入图片中显示的验证码</li></ul>
<h2>第四步：邮箱验证</h2>
<p>提交注册信息后，91n.com 将向您填写的邮箱发送一封验证邮件。请登录您的邮箱，点击邮件中的验证链接完成账号激活。</p>
<h2>第五步：完善个人资料</h2>
<p>账号激活后，您可以登录 91n.com 并完善个人资料，包括头像、昵称、联系方式等，以获得更好的使用体验。</p>
<p>完成以上步骤后，恭喜您！您已经成功注册了 91n.com 账号，现在可以开始体验平台的各项功能了。</p>`,
    category: 'register-login',
    author: '91n官方团队',
    date: '2026-08-01',
    readTime: '5分钟',
    imageQuery: 'Chinese%20website%20registration%20page%20on%20laptop%20screen%20with%20clean%20modern%20design%2C%20warm%20lighting%2C%20minimal%20interface%2C%20professional%20atmosphere',
    imageSeq: 'article-1',
  },
  {
    id: 'article-2',
    title: '忘记 91n.com 密码？三步快速找回教程',
    excerpt: '如果您忘记了 91n.com 的登录密码，不必担心。本文教您通过绑定的邮箱或手机号快速重置密码，恢复账号访问权限。',
    content: `<p>忘记 <strong>91n.com</strong> 密码是很多用户都会遇到的问题。91n.com 提供了便捷的密码找回机制，让您能够在几分钟内恢复账号访问。</p>
<h2>方法一：通过绑定邮箱找回</h2>
<p>在 91n.com 登录页面，点击"忘记密码"链接，输入您注册时使用的邮箱地址，系统将向该邮箱发送密码重置链接，点击链接即可设置新密码。</p>
<h2>方法二：通过绑定手机号找回</h2>
<p>如果您在 91n.com 账号中绑定了手机号，也可以通过手机验证码的方式快速重置密码，更加方便快捷。</p>
<h2>方法三：联系客服协助</h2>
<p>如果以上两种方式都无法使用，您可以通过 91n.com 官方客服渠道寻求帮助，提供账号相关信息后由客服协助恢复。</p>
<h2>安全提示</h2>
<p>为保障您的 91n.com 账号安全，建议定期更换密码，并确保密码具有一定的复杂度，避免使用生日、手机号等容易被猜测的信息作为密码。</p>`,
    category: 'register-login',
    author: '91n安全中心',
    date: '2026-08-03',
    readTime: '3分钟',
    imageQuery: 'Password%20reset%20security%20concept%20on%20a%20modern%20website%20interface%2C%20warm%20neutral%20tones%2C%20clean%20UI%20design%2C%20professional%20tech%20atmosphere',
    imageSeq: 'article-2',
  },
  {
    id: 'article-3',
    title: '91n.com 账号安全设置最佳实践',
    excerpt: '保护您的 91n.com 账号安全至关重要。本文介绍账号安全的各项设置，包括二次验证、登录保护、异常提醒等。',
    content: `<p>在 <strong>91n.com</strong> 平台上，您的账号安全至关重要。本文将详细介绍如何为您的 91n.com 账号设置全面的安全保护。</p>
<h2>开启二次验证</h2>
<p>二次验证是为 91n.com 账号增加额外安全层的有效方式。开启后，每次登录除了密码外还需要输入动态验证码，大幅提升账号安全性。</p>
<h2>设置登录保护</h2>
<p>91n.com 支持设置信任设备列表，在新设备上登录时需要进行额外验证。您可以在账号安全设置中管理信任设备。</p>
<h2>异常登录提醒</h2>
<p>开启异常登录提醒功能后，当 91n.com 检测到您的账号在陌生设备或地区登录时，会立即通过邮件或短信通知您。</p>
<h2>定期安全检查</h2>
<p>建议您每月检查一次 91n.com 账号的安全设置，查看最近的登录记录，及时处理可疑活动。</p>`,
    category: 'security',
    author: '91n安全中心',
    date: '2026-07-28',
    readTime: '4分钟',
    imageQuery: 'Cybersecurity%20concept%20with%20shield%20icon%20on%20digital%20screen%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20design',
    imageSeq: 'article-3',
  },
  {
    id: 'article-4',
    title: '91n.com 核心功能一览：平台能为您做什么',
    excerpt: '全面了解 91n.com 的核心功能模块，从信息浏览到互动交流，从资源下载到个性化设置，一文掌握全部能力。',
    content: `<p><strong>91n.com</strong> 作为综合性网络平台，为用户提供了丰富多样的功能服务。本文将为您全面盘点 91n.com 的核心功能模块。</p>
<h2>信息浏览与搜索</h2>
<p>91n.com 提供强大的信息聚合和搜索功能，用户可以快速找到所需内容，支持关键词搜索和分类浏览两种方式。</p>
<h2>互动交流社区</h2>
<p>在 91n.com 平台中，用户可以参与讨论、发表评论、与其他用户互动交流，构建活跃的社区氛围。</p>
<h2>资源中心</h2>
<p>91n.com 资源中心汇聚了丰富的优质内容资源，用户可以按分类浏览和获取各类资源。</p>
<h2>个性化设置</h2>
<p>91n.com 支持高度个性化的界面和功能设置，用户可以根据自己的偏好定制使用体验。</p>
<h2>消息通知系统</h2>
<p>91n.com 的消息通知系统确保您不会错过任何重要信息，包括系统通知、互动提醒等。</p>`,
    category: 'feature-guide',
    author: '91n产品团队',
    date: '2026-08-05',
    readTime: '6分钟',
    imageQuery: 'Digital%20platform%20features%20overview%20on%20a%20clean%20modern%20interface%2C%20warm%20professional%20design%2C%20multiple%20feature%20icons',
    imageSeq: 'article-4',
  },
  {
    id: 'article-5',
    title: '91n.com 搜索功能高级使用技巧',
    excerpt: '掌握 91n.com 搜索功能的高级用法，学会使用高级筛选、精准匹配等技巧，让您更高效地找到所需信息。',
    content: `<p><strong>91n.com</strong> 的搜索功能远比您想象的强大。掌握以下高级技巧，让您成为搜索达人。</p>
<h2>关键词精准匹配</h2>
<p>在搜索关键词两侧加上双引号，可以对短语进行精确匹配搜索，过滤掉不相关的结果。</p>
<h2>高级筛选功能</h2>
<p>91n.com 搜索支持按时间范围、内容类型、作者等多维度筛选，帮助您快速缩小搜索范围。</p>
<h2>搜索历史与收藏</h2>
<p>91n.com 会自动保存您的搜索历史，方便您回顾之前的搜索。您还可以将常用的搜索条件保存为收藏。</p>
<h2>搜索建议优化</h2>
<p>合理利用 91n.com 的搜索建议功能，系统会根据热门搜索和您的历史行为推荐相关内容。</p>`,
    category: 'feature-guide',
    author: '91n产品团队',
    date: '2026-07-30',
    readTime: '4分钟',
    imageQuery: 'Search%20engine%20optimization%20concept%20on%20a%20digital%20screen%2C%20warm%20lighting%2C%20clean%20modern%20interface%2C%20professional%20design',
    imageSeq: 'article-5',
  },
  {
    id: 'article-6',
    title: '91n.com 最新地址更新公告（2026年8月）',
    excerpt: '为提升服务质量，91n.com 进行了网络优化调整。本文提供最新的 91n.com 官方入口地址及访问建议。',
    content: `<p>尊敬的 <strong>91n.com</strong> 用户：</p>
<p>为持续提升平台服务质量与访问体验，我们对 91n.com 进行了网络架构优化。现将相关事项公告如下：</p>
<h2>官方入口地址</h2>
<p><strong>91n.com</strong> 主域名保持不变，所有用户均可通过 91n.com 正常访问平台。部分地区用户如遇访问延迟，建议尝试清除浏览器缓存后重试。</p>
<h2>访问建议</h2>
<p>建议所有用户将 91n.com 添加至浏览器收藏夹，以便随时快速访问。同时请认准 91n.com 唯一官方域名，谨防仿冒网站。</p>
<h2>服务优化说明</h2>
<p>本次优化主要提升了以下方面：页面加载速度提升约 30%、搜索响应时间缩短、移动端适配更加完善。</p>
<p>感谢您一直以来对 91n.com 的支持与信任！</p>`,
    category: 'announcement',
    author: '91n官方团队',
    date: '2026-08-10',
    readTime: '2分钟',
    imageQuery: 'Official%20announcement%20on%20a%20website%20with%20megaphone%20icon%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20design',
    imageSeq: 'article-6',
  },
  {
    id: 'article-7',
    title: '91n.com 隐私政策与数据保护说明',
    excerpt: '了解 91n.com 如何保护您的个人隐私数据，包括数据收集范围、使用方式、存储安全措施等详细说明。',
    content: `<p><strong>91n.com</strong> 高度重视用户隐私和数据安全。本文详细说明平台的隐私保护政策和数据处理方式。</p>
<h2>数据收集范围</h2>
<p>91n.com 仅收集提供服务所必需的用户数据，包括注册信息、使用偏好等基本数据，绝不会超出合理范围收集额外信息。</p>
<h2>数据使用方式</h2>
<p>收集的数据仅用于优化 91n.com 平台服务体验，包括个性化推荐、安全防护、服务质量改进等目的。</p>
<h2>数据存储安全</h2>
<p>91n.com 采用业界领先的加密技术和安全措施保护用户数据，所有数据传输均经过加密处理。</p>
<h2>用户权利</h2>
<p>用户可以随时查看、修改或删除在 91n.com 上的个人数据，平台提供便捷的数据管理功能。</p>`,
    category: 'security',
    author: '91n法务团队',
    date: '2026-07-25',
    readTime: '5分钟',
    imageQuery: 'Privacy%20policy%20and%20data%20protection%20concept%20on%20a%20digital%20screen%2C%20warm%20professional%20design%2C%20lock%20icon',
    imageSeq: 'article-7',
  },
  {
    id: 'article-8',
    title: '91n.com 平台服务条款更新通知',
    excerpt: '91n.com 近期对用户服务条款进行了更新完善，本文梳理了主要变更内容，建议所有用户仔细阅读。',
    content: `<p>尊敬的 <strong>91n.com</strong> 用户：</p>
<p>为进一步规范平台运营，保障用户权益，我们对 91n.com 用户服务条款进行了更新。以下是本次更新的主要内容：</p>
<h2>账号管理条款优化</h2>
<p>新增了账号注销机制说明，明确了账号注销的条件、流程和数据处理方式。</p>
<h2>内容发布规范</h2>
<p>完善了用户在 91n.com 平台发布内容的规范要求，强调合法合规、尊重他人的原则。</p>
<h2>知识产权保护</h2>
<p>加强了对原创内容和知识产权的保护条款，明确了侵权处理机制。</p>
<h2>生效时间</h2>
<p>新条款将于 2026 年 9 月 1 日起正式生效。如有疑问，欢迎联系 91n.com 客服咨询。</p>`,
    category: 'announcement',
    author: '91n官方团队',
    date: '2026-08-08',
    readTime: '3分钟',
    imageQuery: 'Terms%20of%20service%20document%20on%20a%20desk%20with%20warm%20lighting%2C%20professional%20legal%20atmosphere%2C%20clean%20modern%20design',
    imageSeq: 'article-8',
  },
  {
    id: 'article-9',
    title: '91n.com 常见登录问题排查手册',
    excerpt: '汇总 91n.com 用户登录过程中可能遇到的各种问题及解决方法，包括验证码错误、账号被锁定、页面加载异常等。',
    content: `<p>在使用 <strong>91n.com</strong> 的过程中，登录问题是用户最常遇到的困扰。本文汇总了常见登录问题及其解决方案。</p>
<h2>问题一：验证码错误或无法显示</h2>
<p>如果 91n.com 登录页面的验证码无法显示，请尝试刷新页面或更换浏览器。如仍无法解决，可能是浏览器插件干扰，请暂时关闭广告拦截插件。</p>
<h2>问题二：账号被暂时锁定</h2>
<p>连续多次输入错误密码后，91n.com 会暂时锁定账号。请等待 15 分钟后重试，或使用密码找回功能。</p>
<h2>问题三：页面加载异常</h2>
<p>如果 91n.com 页面加载缓慢或显示异常，请检查网络连接，清除浏览器缓存和 Cookie 后重试。</p>
<h2>问题四：记住密码功能失效</h2>
<p>如果浏览器的记住密码功能在 91n.com 上失效，请检查浏览器设置中是否禁用了密码保存功能。</p>`,
    category: 'faq',
    author: '91n技术支持',
    date: '2026-08-02',
    readTime: '5分钟',
    imageQuery: 'Troubleshooting%20guide%20concept%20on%20a%20laptop%20screen%2C%20warm%20professional%20atmosphere%2C%20question%20mark%20icon',
    imageSeq: 'article-9',
  },
  {
    id: 'article-10',
    title: '如何识别仿冒 91n.com 的钓鱼网站',
    excerpt: '网络安全至关重要。本文教您如何辨别真假 91n.com 网站，避免上当受骗，保护您的账号和财产安全。',
    content: `<p>随着 <strong>91n.com</strong> 用户数量的增长，一些不法分子可能会创建仿冒网站进行钓鱼诈骗。请仔细阅读本文，学会识别真假 91n.com。</p>
<h2>确认官方域名</h2>
<p><strong>91n.com</strong> 的唯一官方域名就是 91n.com。请仔细检查浏览器地址栏，确保域名完全正确，注意是否有字母替换等欺骗手段。</p>
<h2>查看安全证书</h2>
<p>合法的 91n.com 网站使用了 HTTPS 加密连接。请确认地址栏前方有安全锁标志，点击可查看网站安全证书。</p>
<h2>警惕异常链接</h2>
<p>不要点击来路不明的邮件或消息中的 91n.com 链接。始终通过手动输入域名或使用书签访问 91n.com。</p>
<h2>举报仿冒网站</h2>
<p>如发现仿冒 91n.com 的钓鱼网站，请立即通过官方渠道向我们举报，共同维护网络安全环境。</p>`,
    category: 'security',
    author: '91n安全中心',
    date: '2026-07-22',
    readTime: '4分钟',
    imageQuery: 'Phishing%20website%20warning%20concept%20with%20danger%20icon%20on%20digital%20screen%2C%20warm%20professional%20atmosphere',
    imageSeq: 'article-10',
  },
  {
    id: 'article-11',
    title: '91n.com 个性化设置完整教程',
    excerpt: '91n.com 支持丰富的个性化设置选项，从主题配色到通知偏好，打造专属您的使用体验。',
    content: `<p><strong>91n.com</strong> 为用户提供了丰富的个性化设置选项。跟随本教程，打造最适合您的使用体验。</p>
<h2>主题与外观设置</h2>
<p>91n.com 支持多种主题配色方案，您可以根据个人喜好选择明亮模式或暗色模式，还可以调整字体大小。</p>
<h2>通知偏好设置</h2>
<p>在 91n.com 的设置中心，您可以精细控制各类通知的接收方式，包括邮件通知、站内消息等。</p>
<h2>隐私可见性</h2>
<p>您可以设置个人主页的可见范围，控制哪些信息对其他用户可见，保护个人隐私。</p>
<h2>语言与地区</h2>
<p>91n.com 支持多语言界面，您可以根据需要切换显示语言和地区设置。</p>`,
    category: 'feature-guide',
    author: '91n产品团队',
    date: '2026-08-06',
    readTime: '4分钟',
    imageQuery: 'Personalization%20settings%20interface%20on%20a%20modern%20website%2C%20warm%20professional%20design%2C%20clean%20and%20minimal',
    imageSeq: 'article-11',
  },
  {
    id: 'article-12',
    title: '91n.com 注册时收不到验证邮件怎么办',
    excerpt: '如果在注册 91n.com 时没有收到验证邮件，本文提供多种排查方法和解决方案，确保您顺利完成注册。',
    content: `<p>在注册 <strong>91n.com</strong> 时收不到验证邮件是一个常见问题。以下是详细的排查步骤：</p>
<h2>第一步：检查垃圾邮件箱</h2>
<p>91n.com 的验证邮件有时可能被邮箱服务商误判为垃圾邮件。请先查看您的垃圾邮件或广告邮件文件夹。</p>
<h2>第二步：确认邮箱地址正确</h2>
<p>请仔细检查您输入的邮箱地址是否完全正确，确保没有拼写错误或多余的空格。</p>
<h2>第三步：尝试重新发送</h2>
<p>在 91n.com 注册页面，通常有"重新发送验证邮件"的按钮，点击后等待几分钟再查看邮箱。</p>
<h2>第四步：更换邮箱尝试</h2>
<p>如果使用某个邮箱始终无法收到，建议尝试使用其他邮箱服务商注册 91n.com 账号。</p>
<h2>第五步：联系客服</h2>
<p>如果以上方法均无效，请联系 91n.com 官方客服获取进一步帮助。</p>`,
    category: 'faq',
    author: '91n技术支持',
    date: '2026-08-04',
    readTime: '3分钟',
    imageQuery: 'Email%20verification%20concept%20on%20a%20laptop%2C%20warm%20professional%20atmosphere%2C%20envelope%20icon%2C%20modern%20design',
    imageSeq: 'article-12',
  },
];